export const isNotBlank: any = (length: number = 1) => {
    return (value: string, data: any, filedName: string): any => {
        return !(value.replace(/\s/gi, "").length < length);

    }
}
